import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from '.'

export const CsTagIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 875 875" {...props}>
    <g>
      <path
        d="M260.6,187.5c0-20.2-7.1-37.4-21.4-51.7c-14.3-14.3-31.5-21.4-51.7-21.4s-37.4,7.1-51.7,21.4
	c-14.3,14.3-21.4,31.5-21.4,51.7s7.1,37.4,21.4,51.7c14.3,14.3,31.5,21.4,51.7,21.4s37.4-7.1,51.7-21.4
	C253.5,225,260.6,207.6,260.6,187.5z M870.3,516.6c0,20.2-7,37.3-21.1,51.4L568.7,849.2c-14.8,14.1-32.2,21.1-52,21.1
	c-20.2,0-37.3-7-51.4-21.1L56.6,440.1c-14.5-14.1-26.8-33.3-36.9-57.7C9.7,358,4.6,335.6,4.6,315.5V77.7c0-19.8,7.2-37,21.7-51.4
	S57.9,4.7,77.8,4.7h237.7c20.2,0,42.5,5,66.9,15.1s43.8,22.4,58.3,36.9l408.6,408C863.3,479.4,870.3,496.9,870.3,516.6L870.3,516.6z
	"
      />
    </g>
  </StyledIcon>
)

CsTagIcon.displayName = 'CsTagIcon'
